import { registerApplication, start } from "single-spa";

const authToken = localStorage.getItem("authToken") || "";

registerApplication(
  "sidebar",
  // @ts-ignore
  () => import("navigation/Sidebar"),
  (location) => authToken !== ""
);

registerApplication(
  "header",
  // @ts-ignore
  () => import("navigation/Header"),
  (location) => authToken !== ""
);

registerApplication(
  "dashboard",
  // @ts-ignore
  () => import("dashboard/Dashboard"),
  (location) => authToken !== "" && location.hash.startsWith("#/dashboard")
);

registerApplication(
  "products",
  // @ts-ignore
  () => import("products/Products"),
  (location) => authToken !== "" && location.hash.startsWith("#/products")
);

registerApplication(
  "customers",
  // @ts-ignore
  () => import("customers/Customers"),
  (location) => authToken !== "" && location.hash.startsWith("#/customers")
);

registerApplication(
  "booking",
  // @ts-ignore
  () => import("booking/Booking"),
  (location) => authToken !== "" && location.hash.startsWith("#/booking")
);

registerApplication(
  "businessUnit",
  // @ts-ignore
  () => import("businessUnit/BusinessUnit"),
  (location) => authToken !== "" && location.hash.startsWith("#/businessunit")
);

registerApplication(
  "revenueGroups",
  // @ts-ignore
  () => import("revenueGroups/RevenueGroups"),
  (location) => authToken !== "" && location.hash.startsWith("#/revenuegroups")
);

registerApplication(
  "costelements",
  // @ts-ignore
  () => import("costelements/CostElements"),
  (location) => authToken !== "" && location.hash.startsWith("#/elements")
);

registerApplication(
  "pricebooks",
  // @ts-ignore
  () => import("pricebooks/PriceBook"),
  (location) => authToken !== "" && location.hash.startsWith("#/pricebooks")
);

registerApplication(
  "pricetemplates",
  // @ts-ignore
  () => import("pricetemplates/PriceTemplates"),
  (location) => authToken !== "" && location.hash.startsWith("#/pricetemplates")
);

registerApplication(
  "productCategory",
  // @ts-ignore
  () => import("productCategory/ProductCategory"),
  (location) => authToken !== "" && location.hash.startsWith("#/productcategory")
);

registerApplication(
  "approval",
  // @ts-ignore
  () => import("approval/Approval"),
  (location) => authToken !== "" && location.hash.startsWith("#/approval")
);

registerApplication(
  "shipping",
  // @ts-ignore
  () => import("shipping/Shipping"),
  (location) => authToken !== "" && location.hash.startsWith("#/shipping")
);


registerApplication(
  "login",
  // @ts-ignore
  () => import("login/Login"),
  (location) => authToken === "" && (location.pathname.startsWith("/") || location.hash.startsWith("#/login"))
);

registerApplication(
  "roles",
  // @ts-ignore
  () => import("roles/Roles"),
  (location) => authToken !== "" && location.hash.startsWith("#/roles")
);

registerApplication(
  "userRoles",
  // @ts-ignore
  () => import("userRoles/UserRoles"),
  (location) => authToken !== "" && location.hash.startsWith("#/userroles")
);

registerApplication(
  "reports",
  // @ts-ignore
  () => import("reports/Reports"),
  (location) => authToken !== "" && location.hash.startsWith("#/reports")
);


start({  urlRerouteOnly: true });
